import { render, staticRenderFns } from "./chatItem.vue?vue&type=template&id=9adc5cb8"
import script from "./chatItem.vue?vue&type=script&lang=js"
export * from "./chatItem.vue?vue&type=script&lang=js"
import style0 from "./chatItem.vue?vue&type=style&index=0&id=9adc5cb8&prod&lang=scss"
import style1 from "./chatItem.vue?vue&type=style&index=1&id=9adc5cb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports